import { call, select, fork, takeLatest } from 'redux-saga/effects';
import { CellIndex, UtcTime } from 'types';
import { splitStreamId } from 'util/streamId';
import { startOfTodayOnServer } from 'logic/timezones';
import { RestoreLayoutAction } from 'actions/monitoringActions';
import { getTimezoneOffsetCalculator } from 'selectors/serverSelectors';
import { timelineRequestSaga } from './timelineRequestSaga';

export function* restoreLayoutWatcher() {
    yield takeLatest('RESTORE_LAYOUT', restoreLayoutTimelinesSaga);
}

export function* restoreLayoutTimelinesSaga(action: RestoreLayoutAction) {
    const { durableCells } = action.payload;

    const tzOffsetCalculator = yield select(getTimezoneOffsetCalculator);
    const serverToday: UtcTime = yield call(startOfTodayOnServer, tzOffsetCalculator);

    // Fetch the timeline information for each occupied cell
    for (let i = 0; i < durableCells.length; i++) {
        const { streamId, live, streamPosition } = durableCells[i];
        if (!streamId) {
            continue;
        }
        const cellDate = new Date(live ? serverToday : streamPosition);
        const { deviceId } = splitStreamId(streamId);
        const cellIndex = (i + 1) as CellIndex; // because 0th cell is Change Image cell

        yield fork(timelineRequestSaga, deviceId, cellIndex, cellDate);
    }
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/restoreLayoutTimelinesSaga.ts